import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"
import Container from "../components/Container"
import SubHeader from "../components/SubHeader"
import P from "../components/WhiteP"

const HorizontalContainer = styled.div`
  min-width: 100vh;
  display: flex;
  justify-content: space-evenly;
  background-color: #242536;
  padding-bottom: 30px;
  padding-top: 40px;
`

const CenterHorizontalContainer = styled.div`
  min-width: 100vh;
  display: flex;
  justify-content: space-evenly;
  background-color: #242536;
  padding-bottom: 30px;
`
const RedHorizontalContainer = styled.div`
  min-width: 100vh;
  display: flex;
  justify-content: space-around;
  background-color: #242536;
  padding-bottom: 40px;
  padding-top: 40px;
`

const VerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const FontContainer = styled.p`
  font-size: 34px;
  color: white;
  line-height: 80px;
  font-family: "FuturaLight";
`
const Desc = styled.h4`
  margin-top: 30px;
  font-size: 24px;
  color: #ffffff;
  font-weight: normal;
`

const H4 = styled.h4`
  font-size: 24px;
  font-weight: bold;
  color: white;
`

const Padding = styled.div`
  padding: 30px;
  background-color: #242536;
`
const ColorsContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: #242536;
`

const ColorContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 100%;
  background-color: ${props => props.bgColor};
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.33);
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 10px;
`

const ColorDes = styled.h3`
  font-size: 26px;
  color: white;
  margin-top: 20px;
  font-weight: normal;
`

const PrototypingSection = () => {
  const data = useStaticQuery(graphql`
    query {
      
      guide: file(relativePath: { eq: "Guide.jpg" }) {
        childImageSharp {
          fixed(width: 660, height: 510, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      main: file(relativePath: { eq: "HighMain.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      menu: file(relativePath: { eq: "HighMenu.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      reqs: file(relativePath: { eq: "HighReqs.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      search: file(relativePath: { eq: "HighSearch.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      add: file(relativePath: { eq: "HighAdd.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      settings: file(relativePath: { eq: "HighSettings.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      grid: file(relativePath: { eq: "HighGrid.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `)

  return (
    <>
      <Container noTop dark>
        <SubHeader white>High-Fidelity Prototyping</SubHeader>
        <P white>
          After multiple rounds of low-fidelity prototyping, and reaching a
          point where we started feeling confident about our design, we started
          moving on to the High-fidelity prototyping phase. <br /> <br />
          For that, we started picking design elements such as fonts, colors and
          visual language.
        </P>
        <H4>Design</H4>
      </Container>
      <HorizontalContainer>
        <Img fixed={data.guide.childImageSharp.fixed} />
      </HorizontalContainer>
      <Container noTop dark>
        <P>
          We used Rose-Hulman's Brand Identity Guidelines 2.0 as a source for
          our design language. We used the recommended font, and in addition to
          using the proposed primary colors, we choose the secondary colors to
          go with them.
        </P>
        <H4>Font and Colors</H4>
      </Container>
      <Padding>
        <CenterHorizontalContainer>
          <VerContainer>
            <FontContainer>
              Futura <br />A B C D E F G H I J K L M N <br /> O P Q R S T U V W
              X Y Z <br /> a b c d e f g h i j k l m n<br /> o p q r s t u v w x
              y z<br /> 1 2 3 4 5 6 7 8 9 0
            </FontContainer>
          </VerContainer>
          <VerContainer>
            <ColorDes>Primary Colors</ColorDes>
            <ColorsContainer>
              <ColorContainer bgColor={"white"} />
              <ColorContainer bgColor={"#800000"} />
            </ColorsContainer>
            <ColorDes>Secondary Colors</ColorDes>
            <ColorsContainer>
              <ColorContainer bgColor={"#FFF384"} />
              <ColorContainer bgColor={"#ABC584"} />
              <ColorContainer bgColor={"#CCC2D9"} />
            </ColorsContainer>
            <ColorsContainer>
              <ColorContainer bgColor={"#C0E1E5"} />
              <ColorContainer bgColor={"#333333"} />
            </ColorsContainer>
          </VerContainer>
        </CenterHorizontalContainer>
      </Padding>
      <Container noTop dark>
        <H4>Iteration</H4>
        <P>
          After using these elements we went again through multiple rounds of
          proposing design alternatives, prototyping and evaluation. <br />3
          iterations later, we reached to our final design :
        </P>
      </Container>
      <Container noTop dark>
        <SubHeader white>Final Result</SubHeader>
      </Container>
      <RedHorizontalContainer>
        <VerContainer>
          <Img fixed={data.main.childImageSharp.fixed} />
          <Desc>Main</Desc>
        </VerContainer>
      </RedHorizontalContainer>
      <RedHorizontalContainer>
        <VerContainer>
          <Img fixed={data.menu.childImageSharp.fixed} />
          <Desc>Main Menu</Desc>
        </VerContainer>
        <VerContainer>
          <Img fixed={data.reqs.childImageSharp.fixed} />
          <Desc>Requirements Menu</Desc>
        </VerContainer>
      </RedHorizontalContainer>
      <RedHorizontalContainer>
        <VerContainer>
          <Img fixed={data.search.childImageSharp.fixed} />
          <Desc>Search</Desc>
        </VerContainer>
        <VerContainer>
          <Img fixed={data.add.childImageSharp.fixed} />
          <Desc>Adding a Course</Desc>
        </VerContainer>
      </RedHorizontalContainer>
      <RedHorizontalContainer>
        <VerContainer>
          <Img fixed={data.settings.childImageSharp.fixed} />
          <Desc>Settings</Desc>
        </VerContainer>
        <VerContainer>
          <Img fixed={data.grid.childImageSharp.fixed} />
          <Desc>Grid Layout</Desc>
        </VerContainer>
      </RedHorizontalContainer>
    </>
  )
}

export default PrototypingSection
